import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';

export enum CoAppConfirmSheetActions {
	CLOSE = 'close',
	SEND_INVITE = 'sendInvite'
}

@Component({
	selector: 'op-co-app-confirm-sheet',
	templateUrl: './co-app-confirm-sheet.component.html',
	styleUrls: ['./co-app-confirm-sheet.component.scss']
})
export class CoAppConfirmSheetComponent implements OnInit {
	private sheetActions = CoAppConfirmSheetActions;
	constructor(
		private bottomSheetRef: MatBottomSheetRef<CoAppConfirmSheetComponent>,
		private tagDataService: TagDataService,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.tagDataService.view(
			{},
			{
				event_action: 'co_app_review_modal_on_load',
				tealium_event: `co_app_review_modal_on_load`
			}
		);
	}

	closeSheet(action: string): void {
		this.tagDataService.link(
			{},
			{
				event_action: 'co_app_review_modal_action',
				tealium_event: `co_app_review_modal_action`,
				action: action
			}
		);
		this.bottomSheetRef.dismiss(action);
	}

	sendInvite(action: string): void {
		this.closeSheet(action);
	}
}
